import React, { useEffect, useState, useCallback } from 'react';
import { Table, Row, Col, Spin, message, Icon } from 'antd';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { fetchRole, updateRole, resetAddRole, deleteRole } from 'appRedux/actions/Role';
import Widget from 'components/Widget';
import FormFilter from './FormFilter';
import { EditableCell, EditableFormRow } from './EditableCell';
import Columns from './Columns';
import convertData from 'firebase/utils/convertData';

const ListingUser = ({ fetchRole, updateRole, deleteRole, resetAddRole, roleList, loading, updating, deleting, payload, currentUser }) => {
  const [dataSource, setDataSource] = useState([]);
  const [toggle, setToggle] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [processing, setProcessing] = useState(false);
  const convertedData = isEmpty(roleList) ? [] : convertData(roleList, true, true);
  const lineManagers = convertedData.filter(item => item.role === 'line-manager');
  
  const components = {
    body: {
      row: EditableFormRow,
      cell: EditableCell,
    },
  };

  const handleUpdate = (id) => {
    const inputData = dataSource.length === 0 ? convertedData : dataSource;
    const updateData = inputData.find(data => data.id === id);
    updateData.line_manager = updateData.role === 'line-manager' ? '' : updateData.line_manager;
    updateData.updated_at = moment().unix();
    updateData.updated_by = currentUser;
    setProcessing(id);
    updateRole({params: updateData});
  };

  const handleDelete = (id) => {
    setProcessing(id);
    deleteRole({params: id});
  };

  const columns = Columns(disableSubmit, processing, updating, deleting, handleUpdate, handleDelete).map(col => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: record => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleUpdateRow,
        handleError,
        lineManagers,
        loading,
      }),
    };
  });

  const handleUpdateRow = row => {
    const newData = dataSource.length === 0 ? [...convertedData] : [...dataSource];
    const index = newData.findIndex(item => row.index === item.index);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setDataSource(newData);
  };

  const handleToggle = () => {
    setToggle(!toggle);
  };

  const handleFetchData = useCallback((filter) => {
    const filterParams = filter ? { ...filter, role: filter.role || ['line-manager', 'member'] } : { role: ['line-manager', 'member'] };
    fetchRole({
      filter: filterParams,
    });
  }, [fetchRole]);

  const handleError = (id) => {
    setDisableSubmit(id);
  };

  useEffect(() => {
    if (payload.message) {
      if (payload.code === 200) {
        message.success({ content: payload.message, key: 'updatable', duration: 2 });
      } else {
        message.error({ content: payload.message, key: 'updatable', duration: 2 });
      }
      resetAddRole();
    }
  }, [payload.code, payload.message, resetAddRole]);

  useEffect(
    () => {
      handleFetchData()
    },
    [handleFetchData]
  );

  return (
    <>
      <Row>
        <Col span={24}>
          <Spin spinning={false} tip="Đang tải dữ liệu...">
            <Widget
              styleName="gx-order-history"
              title={<h2 className="h4 gx-text-capitalize gx-mb-0">Role permission</h2>}
              extra={
                <p onClick={handleToggle} className="gx-text-primary gx-mb-0 gx-pointer">
                  {toggle ? (
                    <>
                      <Icon type="up-circle" /> Đóng tìm kiếm
                    </>
                  ) : (
                    <>
                      <Icon type="search" /> Bạn cần tìm kiếm dữ liệu ?
                    </>
                  )}
                </p>
              }
            >
              {toggle && <FormFilter onSearch={filter => handleFetchData(filter)} />}
              <Table
                rowKey='id'
                loading={loading}
                className='gx-table-no-bordered'
                pagination={false}
                bordered={false}
                size='small'
                components={components}
                rowClassName={() => 'editable-row'}
                dataSource={convertedData}
                columns={columns}
              />
            </Widget>
          </Spin>
        </Col>
      </Row>
    </>
  );
}

const mapStateToProps = ({ role, auth }) => {
  const { data: roleList, loading, updating, payload, deleting } = role;
  const { currentUser } = auth;
  return { roleList, loading, updating, payload, deleting, currentUser };
};

export default connect(
  mapStateToProps,
  { fetchRole, updateRole, resetAddRole, deleteRole }
)(ListingUser);
